import { render } from "./PopularGroupsPost.vue?vue&type=template&id=73de6d94&scoped=true&lang=pug"
import script from "./PopularGroupsPost.vue?vue&type=script&lang=js"
export * from "./PopularGroupsPost.vue?vue&type=script&lang=js"

import "./PopularGroupsPost.vue?vue&type=style&index=0&id=73de6d94&lang=sass&scoped=true"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73de6d94"]])

export default __exports__